/**
 * App
 */
export * from './app.module';
declare module 'googlemaps';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/index.ts